import React, { useMemo, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import "../../../assets/css/Allfilter.css";

const FilterAllProductpdp = ({
  products = [],
  selectedFilters = {},
  setSelectedFilters,
}) => {
  const [searchText, setSearchText] =
    useState({});

  /* ============================
     FILTER DATA
  ============================ */

  const filters = useMemo(() => {
    // const designSet = new Set();
    // const shadeSet = new Set();
    const sizeSet = new Set();
    const shapeSet = new Set();
    const priceSet = new Set();

    products.forEach((product) => {
      /* DESIGN */

      // if (
      //   product.design !== null &&
      //   product.design !== undefined &&
      //   product.design !== ""
      // ) {
      //   designSet.add(
      //     String(product.design)
      //   );
      // }

      // /* SHADE */

      // if (
      //   product.shade !== null &&
      //   product.shade !== undefined &&
      //   product.shade !== ""
      // ) {
      //   shadeSet.add(
      //     String(product.shade)
      //   );
      // }

      /* SIZES */

      product.sizes?.forEach((sizeItem) => {
        if (
          sizeItem.size !== null &&
          sizeItem.size !== undefined &&
          sizeItem.size !== ""
        ) {
          sizeSet.add(
            String(sizeItem.size)
          );
        }

        /* SHAPE */

        if (
          sizeItem.shape !== null &&
          sizeItem.shape !== undefined &&
          sizeItem.shape !== ""
        ) {
          shapeSet.add(
            String(sizeItem.shape)
          );
        }

        /* PRICE */

        const price = Number(sizeItem.mrp);

        if (
          sizeItem.mrp !== null &&
          sizeItem.mrp !== undefined &&
          !Number.isNaN(price)
        ) {
          priceSet.add(price);
        }
      });
    });

    /* ============================
       PRICE RANGES
    ============================ */

    const prices = [...priceSet].sort(
      (a, b) => a - b
    );

    const priceRanges = [];

    if (prices.length > 0) {
      const rangeSize = 10000;
      const maxPrice = Math.max(...prices);

      let start = 0;

      while (start <= maxPrice) {
        const end =
          start + rangeSize - 1;

        if (start === 0) {
          priceRanges.push({
            text: `Under ₹${rangeSize.toLocaleString(
              "en-IN"
            )}`,
            value: `0-${end}`,
          });
        } else if (end >= maxPrice) {
          priceRanges.push({
            text: `₹${start.toLocaleString(
              "en-IN"
            )}+`,
            value: `${start}+`,
          });

          break;
        } else {
          priceRanges.push({
            text: `₹${start.toLocaleString(
              "en-IN"
            )} - ₹${end.toLocaleString(
              "en-IN"
            )}`,
            value: `${start}-${end}`,
          });
        }

        start += rangeSize;
      }
    }

    return {

      // Design: [...designSet]
      //   .sort((a, b) =>
      //     a.localeCompare(b)
      //   )
      //   .map((value) => ({
      //     text: value,
      //     value,
      //   })),

      // Shade: [...shadeSet]
      //   .sort((a, b) =>
      //     a.localeCompare(b)
      //   )
      //   .map((value) => ({
      //     text: value,
      //     value,
      //   })),

      Size: [...sizeSet]
        .sort((a, b) =>
          a.localeCompare(b)
        )
        .map((value) => ({
          text: value,
          value,
        })),

      Shape: [...shapeSet]
        .sort((a, b) =>
          a.localeCompare(b)
        )
        .map((value) => ({
          text: value,
          value,
        })),

      Price: priceRanges,
    };
  }, [products]);

  /* ============================
     CHECKBOX
  ============================ */

  const handleCheckbox = (
    filterName,
    value
  ) => {
    const key =
      filterName.toLowerCase();

    const selected = Array.isArray(
      selectedFilters?.[key]
    )
      ? selectedFilters[key]
      : [];

    const values = selected.includes(value)
      ? selected.filter(
          (item) => item !== value
        )
      : [...selected, value];

    setSelectedFilters({
      ...selectedFilters,
      [key]: values,
    });
  };

  /* ============================
     PRICE RADIO
  ============================ */

  const handleRadio = (
    filterName,
    value
  ) => {
    const key =
      filterName.toLowerCase();

    setSelectedFilters({
      ...selectedFilters,
      [key]: value,
    });
  };

  /* ============================
     UI
  ============================ */

  return (
    <div className="Accordions-filter">
      <Accordion
        alwaysOpen
        defaultActiveKey={Object.keys(
          filters
        ).map((_, index) =>
          String(index)
        )}
      >
        {Object.entries(filters).map(
          ([filterName, items], index) => {
            const key =
              filterName.toLowerCase();

            const isPrice =
              key === "price";

            const currentSearch =
              searchText[key] || "";

            const filteredItems =
              items.filter((item) => {
                if (!currentSearch) {
                  return true;
                }

                return item.text
                  ?.toLowerCase()
                  .includes(
                    currentSearch.toLowerCase()
                  );
              });

            return (
              <Accordion.Item
                key={filterName}
                eventKey={String(index)}
              >
                <Accordion.Header>
                  {filterName}
                </Accordion.Header>

                <Accordion.Body>

                  {/* SEARCH
                      Price me search nahi */}

                  {!isPrice &&
                    items.length > 8 && (
                      <span className="input-icon-serch">
                        <span className="filter-search-icon">
                          <i className="bi bi-search"></i>
                        </span>

                        <input
                          type="search"
                          className="form-control inputfiletrserach"
                          placeholder={`Search ${filterName}...`}
                          value={currentSearch}
                          onChange={(e) =>
                            setSearchText(
                              (prev) => ({
                                ...prev,
                                [key]:
                                  e.target
                                    .value,
                              })
                            )
                          }
                        />
                      </span>
                    )}

                  <div className="filter-Scroll">
                    {filteredItems.length >
                    0 ? (
                      filteredItems.map(
                        (item, idx) => {
                          const value =
                            item.value;

                          const checked =
                            isPrice
                              ? selectedFilters?.[
                                  key
                                ] === value
                              : Array.isArray(
                                  selectedFilters?.[
                                    key
                                  ]
                                ) &&
                                selectedFilters[
                                  key
                                ].includes(
                                  value
                                );

                          return (
                            <div
                              className="checkbox-container"
                              key={`${key}-${value}-${idx}`}
                            >
                              <label className="checkbox-label">

                                {isPrice ? (
                                  <input
                                    type="radio"
                                    name="pdp-price"
                                    checked={
                                      checked
                                    }
                                    onChange={() =>
                                      handleRadio(
                                        filterName,
                                        value
                                      )
                                    }
                                    style={{
                                      marginRight:
                                        "5px",
                                    }}
                                  />
                                ) : (
                                  <input
                                    type="checkbox"
                                    className="checkbox-input"
                                    checked={
                                      checked
                                    }
                                    onChange={() =>
                                      handleCheckbox(
                                        filterName,
                                        value
                                      )
                                    }
                                  />
                                )}

                                {item.text}
                              </label>
                            </div>
                          );
                        }
                      )
                    ) : (
                      <div className="text-muted py-2">
                        No {filterName.toLowerCase()} found
                      </div>
                    )}
                  </div>

                </Accordion.Body>
              </Accordion.Item>
            );
          }
        )}
      </Accordion>
    </div>
  );
};

export default FilterAllProductpdp;